import { render, staticRenderFns } from "./NewsMain.vue?vue&type=template&id=493f52c2"
import script from "./NewsMain.vue?vue&type=script&lang=js"
export * from "./NewsMain.vue?vue&type=script&lang=js"
import style0 from "./NewsMain.vue?vue&type=style&index=0&id=493f52c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports